var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-item"},[_c('div',{staticClass:"date"},[_c('div',{staticClass:"day"},[_vm._v(_vm._s(_vm.day))]),_c('div',{staticClass:"line"}),_c('div',{staticClass:"month"},[_vm._v(_vm._s(_vm.month))])]),_c('div',{staticClass:"year"},[_vm._v(_vm._s(_vm.year))])])
}
var staticRenderFns = []

export { render, staticRenderFns }